import { Stack, Typography } from "@mui/material";

const FormItem = ({ title, labelStyle, children, required, ...props }) => {
  return (
    <Stack direction="row" my={4} {...props}>
      <Typography sx={{ minWidth: '120px', m: 1, mr: 2, textAlign: 'right' }} style={labelStyle}>
        {required && <Typography variant="span" sx={{ color: 'red', fontSize: 16 }}>*</Typography>}
        {title}
      </Typography>
      {children}
    </Stack>
  );
};

export default FormItem;
